module.exports = __webpack_public_path__ + "img/flickr.37f71517.png";